export const REGIONS = [{
  title: 'West',
  value: 'west',
  children: [{
    title: 'British Columbia',
    value: 'BC',
  }, {
    title: 'Alberta',
    value: 'AB',
  }, {
    title: 'Saskatchewan',
    value: 'SK',
  }, {
    title: 'Manitoba',
    value: 'MB',
  }],
}, {
  title: 'Ontario',
  value: 'ontario',
  children: [{
    title: 'Ontario',
    value: 'ON',
  }, {
    title: 'Thunder Bay',
    value: 'TB',
  }],
}, {
  title: 'Quebec',
  value: 'quebec',
  children: [{
    title: 'Quebec',
    value: 'QC',
  }],
}, {
  title: 'Atlantic',
  value: 'atlantic',
  children: [{
    title: 'Nova Scotia',
    value: 'NS',
  }, {
    title: 'New Brunswick',
    value: 'NB',
  }, {
    title: 'Newfoundland and Labrador',
    value: 'NL',
  }, {
    title: 'Prince Edward Island',
    value: 'PE',
  }],
}, {
  title: 'The North',
  value: 'north',
  children: [{
    title: 'Northwest Territories',
    value: 'NT',
  }, {
    title: 'Yukon',
    value: 'YT',
  }, {
    title: 'Nunavut',
    value: 'NU',
  }],
}];
